import { render, staticRenderFns } from "./home-article.vue?vue&type=template&id=44954138&scoped=true&"
import script from "./home-article.vue?vue&type=script&lang=js&"
export * from "./home-article.vue?vue&type=script&lang=js&"
import style0 from "./home-article.vue?vue&type=style&index=0&id=44954138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44954138",
  null
  
)

/* custom blocks */
import block0 from "./home-article.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports